import PostView from './PostView';
import css from './ListPosts.module.scss';

export default function ListPosts({posts}) {
  return (
    <>
      <div className={css.collectionListWrap}>
        <div role="list" className={css.collectionList}>
          {
            posts.map((post_id) => (
              <PostView key={post_id} id={post_id} type={'short'}/>
            ))
          }
        </div>
      </div>
    </>
  );
}